import { render, staticRenderFns } from "./pgyer.vue?vue&type=template&id=9214c14c&"
import script from "./pgyer.vue?vue&type=script&lang=js&"
export * from "./pgyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports